export const TEST_BLOCKED_REASON = {
  DISABLED: 'disabled',
  NOT_ENOUGH_LEVELS: 'not_enough_levels',
  NO_COURSES: 'no_courses',
  MAX_REACHED: 'max_reached',
} as const;

export type TestBlockedReason =
  (typeof TEST_BLOCKED_REASON)[keyof typeof TEST_BLOCKED_REASON];
